/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { AntwortDisplayModel as AceXFoundPortalCoreCaqModelsAntwortDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/antwort-display-model';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';

@Injectable({
providedIn: 'root',
})

export class AntwortService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiAntwortPost
   */
  static readonly ApiAntwortPostPath = '/api/Antwort';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAntwortPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAntwortPost$Response(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: Array<AceXFoundPortalCoreCaqModelsAntwortDisplayModel>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AntwortService.ApiAntwortPostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAntwortPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAntwortPost(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: Array<AceXFoundPortalCoreCaqModelsAntwortDisplayModel>
  }): Observable<void> {

    return this.apiAntwortPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}